import React, { useState, useEffect } from "react";
import { placeholderImage, imageFallback } from "./config";
import "../styles/Presentations.css";
import Navbar from "./Navbar";
import { FaSearch } from "react-icons/fa";

const Presentations = () => {
  const [presentations, setPresentations] = useState([]);
  const [filteredPresentations, setFilteredPresentations] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [visibleCount, setVisibleCount] = useState(30); // Pehle 16 cards dikhao

  const categories = [
    "All",
    "K12",
    "Mathematics",
    "Vocational",
    "Industry",
    "Technology",
    "Agriculture",
    "UPSC",
    "Medical",
    "Management",
    "Leadership",
  ];

  useEffect(() => {
    fetchPresentations();
  }, []);

  useEffect(() => {
    filterPresentations();
  }, [searchQuery, selectedCategory, presentations]);

  const fetchPresentations = async () => {
    try {
      setLoading(true);
      setError(null);

      const formData = new URLSearchParams();
      formData.append("reg_id", "5");
      formData.append("account_id", "96");

      const response = await fetch(
        "https://technology.skillmaster.net.in/AI_Controller/get_courseware_list",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: formData.toString(),
        }
      );

      if (!response.ok) throw new Error(`Server error ${response.status}`);

      const data = await response.json();

      if (data.Response !== "OK" || !Array.isArray(data.data)) {
        throw new Error(data.message || "No data");
      }

      const items = data.data.filter(item => item.pdf_name && (item.pdf_link || item.presentation_s3_url));

      setPresentations(items);
      setFilteredPresentations(items);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const filterPresentations = () => {
    let filtered = presentations;

    if (selectedCategory !== "All") {
      filtered = filtered.filter(item =>
        [item.core_name, item.category_name, item.sub_category_name]
          .some(str => str?.toLowerCase().includes(selectedCategory.toLowerCase()))
      );
    }

    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      filtered = filtered.filter(item => item.pdf_name?.toLowerCase().includes(q));
    }

    setFilteredPresentations(filtered);
  };

  const handleView = (url) => {
    if (!url) return alert("No file available");
    window.open(
      `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(url)}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  const handleLoadMore = () => {
    setVisibleCount(prev => prev + 14); // Next 16 cards add karo
  };

  return (
    <div className="pres-page-container">

      <div className="pres-page-search-filter-container">
        <div className="pres-page-category-filters">
          {categories.map((cat) => (
            <button
              key={cat}
              className={`pres-page-category-btn ${selectedCategory === cat ? "active" : ""}`}
              onClick={() => setSelectedCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="pres-page-search-box">
          <FaSearch className="pres-page-search-icon" />
          <input
            type="text"
            placeholder="Search presentations..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="pres-page-search-input"
          />
        </div>
      </div>

      <section className="pres-page-grid-section">
        <div className="pres-page-container-inner">
          {loading ? (
            <div className="pres-page-loading-spinner">Loading presentations...</div>
          ) : error ? (
            <div className="pres-page-error-message">
              <p>{error}</p>
              <button onClick={fetchPresentations}>Try Again</button>
            </div>
          ) : filteredPresentations.length === 0 ? (
            <div className="pres-page-no-presentations">
              <p>No presentations found. Try another category or search term.</p>
            </div>
          ) : (
            <>
              <div className="pres-page-grid">
                {filteredPresentations.slice(0, visibleCount).map((item, index) => (
                  <div key={index} className="pres-page-card">
                    <div className="pres-page-thumbnail">
                      <img
                        src={item.pdf_img || placeholderImage(item.pdf_name || "Presentation", 220, 140)}
                        alt={item.pdf_name}
                        loading="lazy"
                        onError={imageFallback(item.pdf_name || "Presentation", 220, 140)}
                      />
                    </div>
                    <div className="pres-page-info">
                      <h3 className="pres-page-title">{item.pdf_name || "Untitled"}</h3>
                      <p className="pres-page-category">
                        {item.sub_category_name || item.category_name || "No category"}
                        {item.core_name && ` • ${item.core_name}`}
                      </p>
                    </div>
                    <button
                      className="pres-page-explore-btn"
                      onClick={() => handleView(item.pdf_link || item.presentation_s3_url)}
                    >
                      Explore
                    </button>
                  </div>
                ))}
              </div>

              {!loading && visibleCount < filteredPresentations.length && (
                <div className="pres-page-load-more-container">
                  <button className="pres-page-load-more-btn" onClick={handleLoadMore}>
                    Load More ({filteredPresentations.length - visibleCount} remaining)
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </section>
    </div>
  );
};

export default Presentations;